import moment from 'moment-timezone';

import Strings from '../../../Strings';
import { CUSTOM, DateFilters } from '../../../utils/DateFilters';

export const ORGLESS_SUPERUSER_ROLE_TITLE = 'orgless_superuser';
export const NONE_ASSIGNEE_FILTER = '__none__';

export const ISSUE_SEVERITY_OPTIONS = [
  { value: 'all', label: Strings.all || 'All' },
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
];

export const ISSUE_CREATE_SEVERITY_OPTIONS = ISSUE_SEVERITY_OPTIONS.filter(option => option.value !== 'all');

export const HEALTH_DATE_FILTER_OPTIONS = [
  DateFilters.Custom,
  DateFilters.Last48Hours,
  DateFilters.Last7Days,
  DateFilters.Last30Days,
  DateFilters.Last6Months,
  DateFilters.AllTime,
];

export function buildCheckboxFilterDefinition(group, text, values) {
  return {
    [group]: {
      group,
      text,
      values: values.map(item => ({
        text: item.label,
        value: String(item.value),
      })),
    },
  };
}

export function getAdvancedFilterValues(filters, group, mapValue = value => value) {
  return filters
    .filter(filter => filter.group === group && filter.state)
    .map(filter => mapValue(filter.value));
}

export function getResponseItems(resp) {
  const data = resp?.response || {};
  if (Array.isArray(data)) {
    return data;
  }
  if (Array.isArray(data.data)) {
    return data.data;
  }
  return [];
}

export function getAssignableUserLabel(user) {
  const fullName = [user?.first_name, user?.last_name].filter(Boolean).join(' ').trim();
  if (fullName && user?.username) {
    return `${fullName} (${user.username})`;
  }
  return fullName || user?.username || user?.email || user?.unguessable_id || '-';
}

export function isUnassignedIssue(issue) {
  return !issue?.assigned_to || !String(issue.assigned_to).trim();
}

export function formatIssueDate(value) {
  return value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : '-';
}

export function resolveDateRange(rangeOption, now = moment()) {
  const end = now.clone();
  const relativeRanges = {
    [DateFilters.Last48Hours.value]: [48, 'hours'],
    [DateFilters.Last7Days.value]: [7, 'days'],
    [DateFilters.Last30Days.value]: [30, 'days'],
    [DateFilters.Last6Months.value]: [6, 'months'],
    [DateFilters.Last12Months.value]: [12, 'months'],
  };
  if (!rangeOption || rangeOption.value === DateFilters.AllTime.value) {
    return { start: moment(0), end };
  }
  const relativeRange = relativeRanges[rangeOption.value];
  if (relativeRange) {
    return { start: end.clone().subtract(...relativeRange), end };
  }
  return {
    start: rangeOption.dates?.startDate ? moment(rangeOption.dates.startDate()) : undefined,
    end: rangeOption.dates?.endDate ? moment(rangeOption.dates.endDate()) : undefined,
  };
}

export function isCustomDateRangeOption(option) {
  return option?.value === CUSTOM;
}
